import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { fadeInUpAnimation } from '../../shared/animations';
import { fadeInDownAnimation } from '../../shared/animations/fade-in-down.animation';

@Component({
  selector: 'app-chi-siamo',
  standalone: true,
  imports: [CommonModule],
  animations: [fadeInUpAnimation, fadeInDownAnimation],
  templateUrl: './chi-siamo.component.html',
  styleUrls: ['./chi-siamo.component.scss']
})
export class ChiSiamoComponent {}


